<template>
    <div class="xc-page reset xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/user'">系统设置</router-link>
                <a>组合模式</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form
                            class="xc-form"
                            name="search"
                            @submit.prevent="mix_search"
                        >
                         
                            <div class="xc-form-inline">
                                <xc-form-item label="模式名称:">
                                    <input
                                        type="text"
                                        name="compositeName"
                                        v-model="mix_query.compositeName"
                                        class="xc-input"
                                        placeholder="请输入模式名称"
                                    >
                                </xc-form-item>
                                <xc-form-item label="模式指令:">
                                    <input
                                        type="text"
                                        name="voiceCommand"
                                        v-model="mix_query.voiceCommand"
                                        class="xc-input"
                                        placeholder="请输入模式指令"
                                    >
                                </xc-form-item>
                                <xc-form-item label="状态:">
                                    <select
                                        class="xc-select"
                                        name="stopStatus"
                                        v-model="mix_query.stopStatus"
                                    >
                                        <option value selected>全部</option>
                                        <option value="0">启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button
                                        type="submit"
                                        class="xc-btn xc-btn-primary"
                                    >查询
                                    </button>
                                    <button
                                        class="xc-btn xc-btn-default"
                                        type="button"
                                        @click="add"
                                    >添加
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>模式名称</th>
                                    <th>场景名称</th>
                                    <th>音乐类型</th>
                                    <th>分组/音乐名称</th>
                                    <th>模式指令</th>
                                    <th>状态</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{item.compositeName}}</td>
                                        <td>{{item.scenarioName}}</td>
                                        <td>{{item.musicType | getMusicType}}</td>
                                        <td>{{item.musicType == 1?item.musicName:item.musicGroupName}}</td>
                                        <td>{{item.voiceCommand}}</td>
                                        <td>{{item.stopStatus | getStatus}}</td>
                                        <td>
                                            <xc-btn-select
                                                title="管理"
                                            >
                                                <template v-if="groups(item).length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in groups(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>
        <div class="xc-card">
            <!--添加/编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName =='add' || modalName =='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName =='add'?'添加组合模式':'编辑组合模式' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body" style="max-height: 500px;">
                            <form
                                class="xc-form"
                                name="add"
                                data-vv-scope="add"
                            >
                                <xc-form-item
                                    label="模式名称:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="compositeName"
                                        class="xc-input"
                                        v-validate="'required'"
                                        data-vv-as="模式名称"
                                        v-model="fomData.compositeName"
                                        placeholder="请输入模式名称"
                                        :class="{'xc-input-error':errors.first('compositeName','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("compositeName","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="场景名称："
                                    required
                                    :error="errors.first('scenarioId','add')"
                                >
                                    <select
                                        name="scenarioId"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="场景名称："
                                        v-model="fomData.scenarioId"
                                    >   
                                        <option value>请选择</option>
                                        <option
                                            v-for="(item,index) in scenarioList"
                                            :value="item.scenarioId"
                                            :key="index"
                                        >{{ item.scenarioName }}</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item
                                    label="音乐类型："
                                    required
                                    :error="errors.first('musicType','add')"
                                >
                                    <select
                                        name="musicType"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="音乐类型"
                                        v-model="fomData.musicType"
                                    >
                                        <option
                                            value="0"
                                            selected
                                        >分组音乐</option>
                                        <option value="1">独立音乐</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item
                                    label="音乐名称："
                                    required
                                    v-if="fomData.musicType == '1'"
                                    :error="errors.first('musicId','add')"
                                >
                                    <select
                                        name="musicId"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="音乐名称"
                                        v-model="fomData.musicId"
                                    >
                                        <option value>请选择</option>
                                        <option
                                            v-for="(item,index) in musicNameList"
                                            :value="item.musicId"
                                            selected
                                            :key="index"
                                        >{{ item.musicName }}</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item
                                    label="音乐分组："
                                    required
                                    v-else
                                    :error="errors.first('musicGroupId','add')"
                                >
                                    <select
                                        name="musicGroupId"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="音乐分组"
                                        v-model="fomData.musicGroupId"
                                    >
                                        <option value>请选择</option>
                                        <option
                                            v-for="(item,index) in musicGroupList"
                                            :value="item.musicGroupId"
                                            selected
                                            :key="index"
                                        >{{ item.musicGroupName }}</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item
                                    label="服务指令:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="voiceCommand"
                                        class="xc-input"
                                        v-model="fomData.voiceCommand"
                                        v-validate="'required'"
                                        data-vv-as="服务指令"
                                        placeholder="请输入服务指令"
                                        :class="{'xc-input-error':errors.first('voiceCommand','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("voiceCommand","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="状态："
                                    required
                                >
                                    <select
                                        name="stopStatus"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="状态"
                                        v-model="fomData.stopStatus"
                                    >
                                        <option
                                            value="0"
                                            selected
                                        >启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--启用/禁用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='active' || modalName =='disabled'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName=='active'?'启用':'禁用' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            {{ modalName=='active'?'确定启用该组合模式，启用后将恢复正常？':'确定禁用该组合模式，禁用后该组合模式不能使用？' }}
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="enableSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该信息？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import "@/libs/font-awesome"
import "@/libs/vee-validate"
import "@/libs/vue-select"
import "@/utils/form-format"
import compositeApi from "@/api/composite"
import myLayerImport from '@/libs/myLayer';

// ip格式化
import "@/utils/ip-format";
myLayerImport();
export default {
    name: 'systemComposite',
    mixins: [listMixin],
    data() {
        return {
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',

            list: [],
            // 默认查询参数
            mix_query: {
                compositeName: "",
                voiceCommand: "",
                stopStatus: ""
            },
            group: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name: "删除",
                    id: 1
                },
                {
                    name: "启用",
                    id: 2,
                },
                {
                    name: "禁用",
                    id: 3,
                }
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,  //当前表行
            fomData: { 
                musicType: 0,
                stopStatus:0
            },  //表单数据
            scenarioList:[], // 场景列表
            musicGroupList:[], // 音乐分组列表
            musicNameList:[], //音乐名称列表
        }
    },
    filters: {
        getMusicType: function (value) {
            if (value == 0) {
                return "分组音乐"
            }
            return "独立音乐";
        },
        getStatus: function (value) {
            if (value == 0) {
                return "启用"
            }
            return "禁用";
        }
    },
    created() {
        this.getSelectList()
    },
    methods: {
        // 初始化数据
        initData() {
            var _this = this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }
            //请求列表数据
            compositeApi.getCompositeScenarioByPage({params:search}).then(function (ret) {
                _this.list = _this.mix_format(ret.data.list);
                _this.mix_total = ret.data.total;
                _this.mix_page = ret.data.pageNum;
                _this.mix_pageSize = ret.data.pageSize;
            }).catch(function (error) {
                console.log(error)
            });
        },
        getSelectList() {
            var _this = this;
            compositeApi.getScenarioList().then(function (ret) {
                _this.scenarioList = ret.data;
            }).catch(function (error) {
                console.log(error)
            });
            compositeApi.getMusicGroupList().then(function (ret) {
                _this.musicGroupList = ret.data;
            }).catch(function (error) {
                console.log(error)
            });
            compositeApi.getMusicList().then(function (ret) {
                _this.musicNameList = ret.data;
            }).catch(function (error) {
                console.log(error)
            });
        },
        // 更新分页
        pageChange: function (page, pageSize) {
            this.mix_page = page;
            this.mix_pageSize = pageSize;
            this.initData();
        },
        // 打开添加弹窗
        add() {
            this.modalName = "add";
            this.fomData = {
                scenarioId: "",
                musicId:"",
                musicGroupId:'',
                musicType: 0,
                stopStatus:0
            };
        },
        // 操作单条数据
        action(...args) {
            const [action, item] = args;
            this.current = { ...item };
            this.fomData = { ...item };
            switch (action.name) {
                case "编辑":
                    this.modalName = "edit";
                    break;
                case "启用":
                    this.modalName = "active";
                    break;
                case "禁用":
                    this.modalName = "disabled";
                    break;
                case "删除":
                    this.modalName = "delete";
                    break;
                default:
                    break;
            }
        },
        groups: function (item) {
            var arr = this.group.slice(0);
            if (item.stopStatus == 0) {
                //0表示启用,1表示禁用
                arr.splice(2, 1);
            } else {
                arr.splice(3, 1)
            }
            return arr;
        },
        // 添加确定
        addSubmit: function () {
            var myForm = document.add;
            // 验证器命名空间
            const scope = 'add';
            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    const data = this.$formFormat(myForm);
                    if(this.modalName === "add"){
                        compositeApi.addCompositeScenario(data).then(() => {
                            this.$message.success("添加成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }else{
                        data.compositeId = this.current.compositeId;
                        compositeApi.updateCompositeScenario(data).then(() => {
                            this.$message.success("修改成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }
                } else {
                    return false;
                }

            })
        },

        //启用、禁用
        enableSubmit: function () {
            var _this = this;
            var currentstatus = 0;
            if(this.modalName=='disabled'){
                currentstatus = 1;
            }
            var obj = {
                compositeId: this.current.compositeId,
                stopStatus: currentstatus
            };
            compositeApi.updateCompositeStatus(obj).then(function () {
                var statusText = '启用成功';
                if(_this.modalName === 'disabled'){
                    statusText = '禁用成功';
                }
                _this.$message.success(statusText);
                _this.modalName = null;
                _this.initData();
            }).catch(function (error) {
                console.log(error)
            })
        },
        // 删除确认
        deleteSubmit() {
            compositeApi.deleteCompositeScenario(this.current.compositeId).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        }
      
    }
}
</script>

<style  lang="scss">
@import "../xc-ui/scss/variable";
.reset {
    form[name="reset"] {
        .xc-form-item-label {
            width: 80px;
        }
    }
}

</style>

